import * as React from 'react';
import styles from './index.less';
import UserInfo from './UserInfo';
import EmptyAndCreate from './EmptyAndCreate';
import NavList from './NavList';
import AOrLink from './AOrLink';
import { FUtil, FI18n } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import { Space } from 'antd';
import FIcons from '@/components/FIcons';
import FPopover from '../FPopover';
import FHotspotTooltip from '../FHotspotTooltip';

interface FHeaderNavigationProps {
  logoBtn: {
    href: string;
    target?: '_self' | '_blank';
  };
  showAlphaTest?: boolean;
  showConsoleBabel?: boolean;
  menu?: {
    id: string;
    text: string;
    href: string;
    target?: '_self' | '_blank';
    items: {
      id: string;
      text: string;
      href: string;
      target?: '_self' | '_blank';
    }[];
    createBtn?: {
      href: string;
      target?: '_self' | '_blank';
    } | null;
    emptyItemsTip?: {
      tipText: string;
      btnText: string;
      btnHref: string;
      target?: '_self' | '_blank';
    };
  }[];
  activeIDs?: [string, string];
  extra?: React.ReactNode;
  showGotoConsole?: boolean;
  createBtnMenu?: {
    id: string;
    text: string;
    href: string;
    target?: '_self' | '_blank';
  }[];
  userPanel: {
    info: {
      avatar: string;
      userName: string;
      email: string;
      phone: string;
    };
    menu: {
      text: string;
      onClick(): void;
    }[];
  } | null;
  showHotspotTooltip?: boolean;
}

function FHeaderNavigation({
  logoBtn,
  showAlphaTest = false,
  showConsoleBabel = false,
  menu = [],
  activeIDs = ['', ''],
  extra,
  showGotoConsole = false,
  createBtnMenu = [],
  userPanel,
  showHotspotTooltip,
}: FHeaderNavigationProps) {
  const ref = React.useRef(null);
  return (
    <div className={styles.FHeaderNavigation} ref={ref}>
      <div className={styles.FHeaderNavigation_Left}>
        <AOrLink href={logoBtn.href} className={styles.logoLink}>
          <i className={'freelog fl-icon-a-featherlogo5'} />
          {showConsoleBabel && (
            <>
              <div style={{ width: 10 }} />
              {/* <span>· 工作台</span> */}
              <span>· {FI18n.i18nNext.tAuto('nav_console')}</span>
            </>
          )}
        </AOrLink>

        {showAlphaTest && (
          <>
            <div style={{ width: 10 }} />
            <label className={styles.alphaTestLabel}>内测</label>
          </>
        )}

        {menu && menu.length > 0 && (
          <>
            <div style={{ width: 25 }} />
            <div className={styles.Menus}>
              {menu.map((m) => {
                return (
                  <MenuDropdown
                    key={m.id}
                    m={m}
                    activeIDs={activeIDs}
                    showHotspotTooltip={showHotspotTooltip || false}
                  />
                );
              })}
            </div>
          </>
        )}
      </div>
      <div className={styles.FHeaderNavigation_Right}>
        {extra}

        <div style={{ width: 30 }} />

        <Space size={30}>
          {showGotoConsole && (
            <>
              {showHotspotTooltip ? (
                // <FComponentsLib.FHotspotTooltip
                <FHotspotTooltip
                  id={'header.gotoConsoleBtn'}
                  style={{ left: '50%', marginLeft: -16, bottom: -42 }}
                  text={FI18n.i18nNext.tAuto('hotpots_home_btn_gotoconsole')}
                  onMount={() => {
                    FComponentsLib.fSetHotspotTooltipVisible('header.gotoConsoleBtn', {
                      value: false,
                      effectiveImmediately: false,
                      onlyNullish: false,
                    });
                  }}
                >
                  <FComponentsLib.FRectBtn
                    size='small'
                    type='secondary'
                    onClick={() => {
                      window.open(
                        FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.dashboard(),
                      );
                    }}
                  >
                    {/* 进入工作台 */}
                    {FI18n.i18nNext.tAuto('nav_GotoConsole')}
                  </FComponentsLib.FRectBtn>
                </FHotspotTooltip>
              ) : (
                <FComponentsLib.FRectBtn
                  size='small'
                  type='secondary'
                  onClick={() => {
                    window.open(
                      FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.dashboard(),
                    );
                  }}
                >
                  {/* 进入工作台 */}
                  {FI18n.i18nNext.tAuto('nav_GotoConsole')}
                </FComponentsLib.FRectBtn>
              )}
            </>
          )}

          {createBtnMenu && createBtnMenu.length > 0 && (
            <>
              <FComponentsLib.FDropdown
                // open={true}
                // getPopupContainer={() => {
                //   return ref.current || self.document.body;
                // }}
                overlay={<NavList items={createBtnMenu} />}
                overlayStyle={{
                  zIndex: 1000,
                }}
              >
                <a className={styles.createBtnMenu} id={'header.createBtn'}>
                  <span>
                    <FIcons.FPlus />
                  </span>
                </a>
              </FComponentsLib.FDropdown>
            </>
          )}

          <UserInfo data={userPanel} />
        </Space>
      </div>
    </div>
  );
}

export default FHeaderNavigation;

interface MenuDropdownProps {
  m: NonNullable<FHeaderNavigationProps['menu']>[number];
  activeIDs: NonNullable<FHeaderNavigationProps['activeIDs']>;
  showHotspotTooltip: NonNullable<FHeaderNavigationProps['showHotspotTooltip']>;
}

function MenuDropdown({ m, activeIDs, showHotspotTooltip }: MenuDropdownProps) {
  const [$open, set$open, get$open] = FUtil.Hook.useGetState<boolean>(false);
  // console.log($open, 'm ***********************************');
  return (
    <FPopover
      placement='bottomLeft'
      trigger={'hover'}
      arrow={false}
      // zIndex={100000}
      open={$open}
      // open={!(m.items.length === 0 && !m.emptyItemsTip) && visible}
      onOpenChange={(v) => {
        // console.log(v, 'v ***********************************');
        set$open(v);
      }}
      key={m.id}
      // disabled={m.items.length === 0 && !m.emptyItemsTip}
      content={
        <>
          {m.items.length === 0 && m.emptyItemsTip && (
            <EmptyAndCreate
              {...m.emptyItemsTip}
              onSelect={() => {
                set$open(false);
              }}
            />
          )}{' '}
          {m.items.length > 0 && (
            <NavList
              items={m.items}
              createBtn={m.createBtn}
              activeID={activeIDs[1]}
              onSelect={() => {
                set$open(false);
              }}
            />
          )}
        </>
      }
    >
      {m.id === 'discover' && showHotspotTooltip ? (
        <div>
          {/* <FComponentsLib.FHotspotTooltip */}
          <FHotspotTooltip
            id={'header.discoverNav'}
            style={{ left: '50%', marginLeft: -16, bottom: -20 }}
            text={FI18n.i18nNext.tAuto('hotpots_myresource_nav_explore')}
          >
            <AOrLink
              href={m.href}
              target={m.target}
              className={[styles.NavLink, activeIDs[0] === m.id ? styles.activated : ''].join(' ')}
            >
              <span>{m.text}</span>
            </AOrLink>
          </FHotspotTooltip>
        </div>
      ) : (
        <div>
          <AOrLink
            href={m.href}
            target={m.target}
            className={[styles.NavLink, activeIDs[0] === m.id ? styles.activated : ''].join(' ')}
          >
            <span>{m.text}</span>
          </AOrLink>
        </div>
      )}
    </FPopover>
  );
}
